// Visible toasts amount
const VISIBLE_TOASTS_AMOUNT = 3

// Viewport padding
const VIEWPORT_OFFSET = '24px'

// Mobile viewport padding
const MOBILE_VIEWPORT_OFFSET = '16px'

// Default lifetime of a toasts (in ms)
const TOAST_LIFETIME = 4000

// Default toast width
const TOAST_WIDTH = 356

// Default gap between toasts
const GAP = 14

// Threshold to dismiss a toast
const SWIPE_THRESHOLD = 45

// Equal to exit animation duration
const TIME_BEFORE_UNMOUNT = 200

export {
  VISIBLE_TOASTS_AMOUNT,
  VIEWPORT_OFFSET,
  MOBILE_VIEWPORT_OFFSET,
  TOAST_LIFETIME,
  TOAST_WIDTH,
  GAP,
  SWIPE_THRESHOLD,
  TIME_BEFORE_UNMOUNT
}
